import $ from 'jquery'
import _ from 'lodash'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'

import api from '@/api/api'

import MenuMoreOptions from '@/components/general/menu-more-options/menu-more-options'
import TextField from '@/components/general/fields/text/text'
import TextareaField from '@/components/general/fields/textarea/textarea'
import SelectField from '@/components/general/fields/select/select'
import SearchField from '@/components/general/fields/search/search'
import CheckboxField from '@/components/general/fields/checkbox/checkbox'
import FileField from '@/components/general/fields/file/file'
import DateField from '@/components/general/fields/date/date'
import SortField from '@/components/general/fields/sort/sort'

export default {
  name: 'history-contracts',
  data () {
    return {
      contracts: [],
      contractHistoryOptions: [],
      menuOptions: [
        {
          iconClass: 'fa fa-pencil',
          name: this.$t('private.history.contracts.menu_more_options.edit_contract'),
          action: 'edit'
        },
        {
          iconClass: 'fa fa-archive',
          name: this.$t('private.history.contracts.menu_more_options.archive_contract'),
          action: 'archive'
        }
      ],
      selectYears: {
        id: _.uniqueId('field_'),
        display: true,
        fakeValue: '',
        value: '',
        name: this.$t('private.history.contracts.selectYears'),
        error: false,
        active: false,
        options: [],
        style: {
          width: '230px',
          display: 'inline-block',
          margin: '0px 10px'
        }

      },
      filters: {
        ascending: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.sort_ascending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.sort_options.created_at'),
            value: 'appCreationDate'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        descending: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.history.contracts.filters.sort_options.created_at'),
          value: 'appCreationDate',
          name: this.$t('private.history.contracts.filters.sort_descending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.sort_options.created_at'),
            value: 'appCreationDate'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: 50,
          value: 50,
          name: this.$t('private.history.contracts.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: 10,
            value: 10
          }, {
            fakeValue: 25,
            value: 25
          }, {
            fakeValue: 50,
            value: 50
          }, {
            fakeValue: 100,
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        state: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.state'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.state_options.green'),
            value: 0
          }, {
            fakeValue: this.$t('private.history.contracts.filters.state_options.red'),
            value: 1
          }, {
            fakeValue: this.$t('private.history.contracts.filters.state_options.yellow'),
            value: 2
          }, {
            fakeValue: this.$t('private.history.contracts.filters.state_options.black'),
            value: 3
          }, {
            fakeValue: this.$t('private.history.contracts.filters.state_options.purple'),
            value: 4
          }],
          style: {
            width: '100px',
            marginTop: '0px'
          }
        },
        exported: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.history.contracts.filters.exported_options.no'),
            value: false
          }],
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        hidden: { // ESTO SE HACE POR QUE AL PARECER HAY UN BUG EN LOS FILTROS DENTRO DE LA TABLA Y ESTO LO SOLUCIONA
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.history.contracts.filters.exported_options.no'),
            value: false
          }],
          style: {
            display: 'none'
          }
        },
        since: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.since'),
          error: false,
          active: false,
          style: {
            width: '110px',
            marginTop: '3px'
          }
        },
        until: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.until'),
          error: false,
          active: false,
          style: {
            width: '110px'
          }
        },
        seller: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.history.contracts.filters.seller'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        delegation: {
          id: _.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.delegation'),
          error: false,
          active: false,
          options: [],
          style: {
            width: '120px',
            marginTop: '0px'
          }
        },
        clientCode: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.history.contracts.filters.client_code'),
          type: 'text',
          error: false,
          filters: {
            maxLength: 10
          },
          style: {
            width: '150px',
            marginTop: '0px'
          }
        },
        clientLegalName: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.history.contracts.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        legalName: {
          id: _.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.history.contracts.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        skip: {
          value: 0
        }
      },
      getContractsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      getSearchClients: false,
      getClientsActive: false,
      getDelegationsActive: false,
      exportContractsActive: false,
      migrateContractsWindow: {
        display: false,
        migrateCSVFileActive: false,
        contractsToCreated: [],
        contractsToUpdate: [],
        contractsWithErrors: [],
        fields: {
          separator: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: _.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      displayFoo: false,
      totalContracts: 0,
      exportZipPDFsWindow: {
        display: false,
        downloadZipPDFsActive: false,
        fields: {
          month: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.january'),
              value: '01'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.february'),
              value: '02'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.march'),
              value: '03'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.april'),
              value: '04'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.may'),
              value: '05'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.june'),
              value: '06'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.july'),
              value: '07'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.august'),
              value: '08'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.september'),
              value: '09'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.october'),
              value: '10'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.november'),
              value: '11'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.december'),
              value: '12'
            }],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.history.contracts.export_zip_pdfs_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        }
      },
      createHistoryWindow: {
        display: false,
        createHistoryActive: false,
        fields: {
          month: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: true,
            name: this.$t('private.history.contracts.create_history_window.fields.month'),
            error: false,
            active: false,
            options: [],
            // options : [{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.january'),
            //   value : '01'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.february'),
            //   value : '02'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.march'),
            //   value : '03'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.april'),
            //   value : '04'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.may'),
            //   value : '05'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.june'),
            //   value : '06'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.july'),
            //   value : '07'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.august'),
            //   value : '08'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.september'),
            //   value : '09'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.october'),
            //   value : '10'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.november'),
            //   value : '11'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.december'),
            //   value : '12'
            // }],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: _.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.history.contracts.create_history_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        },
        progress: {
          display: false,
          value: 0,
          valueMax: 0
        }
      }
    }
  },
  methods: {
    filterSubmit: _.debounce(function () {
      let vm = this

      vm.getContracts()
    }, 1000),
    rowClicked (element, value) {
      element.rowSelected = value

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true
    },
    actionSort (event, col) {
      let vm = this

      vm.filters.ascending.value = ''
      vm.filters.descending.value = ''

      if (event.sort_default) vm.filters.descending.value = 'appCreationDate'

      if (event.sort_asc) vm.filters.ascending.value = col

      if (event.sort_desc) vm.filters.descending.value = col

      vm.getContracts()
    },
    optionsGetContractsHistory () {
      let vm = this

      vm.contractHistoryOptions = []

      let dataToSend = {
        className: 'ContractHistory',
        descending: 'year'
      }

      api
        .contractsHistory
        .getContractsHistory(dataToSend)
        .then((response) => {
          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (response.data.contracts.length > 0) {
            vm.contractHistoryOptions = response.data.contracts

            _.each(vm.contractHistoryOptions, function (element) {
              vm.selectYears.options.push({
                fakeValue: element.slugContract,
                value: element._id
              })
            })

            vm.selectYears.fakeValue = vm.contractHistoryOptions[0].slugContract
            vm.selectYears.value = vm.contractHistoryOptions[0]._id
            this.$refs['selectYears'].field.value = vm.selectYears.value
            this.$refs['selectYears'].field.fakeValue = vm.selectYears.fakeValue

            vm.getContracts()
          }
        })
    },
    getContracts () {
      let vm = this

      vm.exportContractsActive = false
      vm.contracts = []

      let contractHistory

      if (vm.selectYears.value) {
        contractHistory = vm.contractHistoryOptions.find(element => {
          return element._id === vm.selectYears.value
        })
      } else {
        contractHistory = vm.contractHistoryOptions[0]
      }

      if (!contractHistory) return false

      vm.totalContracts = 0

      vm.getContractsActive = true

      let dataToSend = {
        className: contractHistory.classNameContract,
        ascending: vm.filters.ascending.value,
        descending: vm.filters.descending.value,
        limit: (vm.filters.limit.value + 1),
        skip: vm.filters.skip.value,
        contractState: vm.filters.state.value,
        exported: vm.filters.exported.value,
        since: vm.filters.since.value,
        until: vm.filters.until.value,
        sellerUsername: vm.filters.seller.value,
        clientCode: vm.filters.clientCode.value,
        clientLegalName: vm.filters.legalName.value
      }

      if (vm.filters.delegation.value) {
        let delegation = _.find(vm.filters.delegation.options, function (element) {
          return element.value == vm.filters.delegation.value
        })

        dataToSend.sellerDelegationName = delegation.fakeValue
      }

      api
        .contractsHistory
        .getContractsHistory(dataToSend)
        .then((response) => {
          vm.getContractsActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.contracts = response.data.contracts
          vm.totalContracts = response.data.countContracts || contractHistory.countContracts

          if (vm.contracts.length > 0 && !vm.haveData) {
            vm.haveData = true
          }

          if (vm.contracts.length > vm.filters.limit.value) {
            vm.nextPage = true

            vm.contracts.pop()
          } else {
            vm.nextPage = false
          }

          _.each(vm.contracts, function (x) {
            let prestigeSalonValue = x.prestigeSalonValue ? x.prestigeSalonValue * 1 : 0
            let premiumSalonValue = x.premiumSalonValue ? x.premiumSalonValue * 1 : 0
            x.sumSalonValue = prestigeSalonValue + premiumSalonValue

            let premiumDiscount1 = x.premiumDiscount1 ? x.premiumDiscount1 * 1 : 0
            let premiumVariableDiscount1 = x.premiumVariableDiscount1 ? x.premiumVariableDiscount1 * 1 : 0
            x.premiumDiscountTotal = premiumDiscount1 + premiumVariableDiscount1

            let prestigeDiscount1 = x.prestigeDiscount1 ? x.prestigeDiscount1 * 1 : 0
            let prestigeVariableDiscount1 = x.prestigeVariableDiscount1 ? x.prestigeVariableDiscount1 * 1 : 0
            x.prestigeDiscountTotal = prestigeDiscount1 + prestigeVariableDiscount1
          })
        })
    },
    goToBackPage () {
      let vm = this

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value

        vm.getContracts()
      }
    },
    goToNextPage () {
      let vm = this

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value

        vm.getContracts()
      }
    },
    optionSelected (data) {
      let vm = this

      if (data.action == 'edit') {
        let stateFakeValue =
          data.element.state == 0 ? this.$t('private.history.contracts.fields.state_options.green')
            : data.element.state == 1 ? this.$t('private.history.contracts.fields.state_options.red')
              : data.element.state == 2 ? this.$t('private.history.contracts.fields.state_options.yellow')
                : data.element.state == 3 ? this.$t('private.history.contracts.fields.state_options.black')
                  : data.element.state == 4 ? this.$t('private.history.contracts.fields.state_options.purple') : ''

        if (data.element.client) {
          vm.formUpdate.fields.client.value = data.element.client.id
          vm.formUpdate.fields.clientCode.value = data.element.client.clientCode
        }

        if (data.element.client && data.element.client.associatedAccounts && data.element.client.associatedAccounts.length > 0) {
          let value = {}
          let options = {}

          _.map(data.element.client.associatedAccounts, (associatedAccount) => {
            value[associatedAccount.clientCode] =
              data.element.associatedAccount1 == associatedAccount.clientCode ? true
                : data.element.associatedAccount2 == associatedAccount.clientCode ? true
                  : data.element.associatedAccount3 == associatedAccount.clientCode ? true
                    : data.element.associatedAccount4 == associatedAccount.clientCode ? true
                      : data.element.associatedAccount5 == associatedAccount.clientCode

            options[associatedAccount.clientCode] = {
              name: associatedAccount.legalName + ' (' + associatedAccount.clientCode + ')',
              cif: associatedAccount.cif,
              legalName: associatedAccount.legalName,
              email: associatedAccount.email,
              employeesQuantity: associatedAccount.employeesQuantity,
              disabled: true
            }
          })

          vm.formUpdate.fields.associateAccounts.value = value
          vm.formUpdate.fields.associateAccounts.options = options
          vm.formUpdate.fields.associateAccounts.display = true
        }

        let proratedFakeValue =
          data.element.prorated == true ? this.$t('private.history.contracts.fields.prorated_options.yes')
            : data.element.prorated == false ? this.$t('private.history.contracts.fields.prorated_options.no') : ''

        vm.formUpdate.fields.id.value = data.element.id
        vm.formUpdate.fields.state.fakeValue = stateFakeValue
        vm.formUpdate.fields.state.value = data.element.state
        vm.formUpdate.fields.prestigeDate.value = data.element.prestigeDate ? this.parseDate(data.element.prestigeDate.iso) : ''
        vm.formUpdate.fields.prestigeATS.value = data.element.prestigeATS ? data.element.prestigeATS : 0
        vm.formUpdate.fields.prestigeMTKG.value = data.element.prestigeMTKG ? data.element.prestigeMTKG : ''
        vm.formUpdate.fields.prestigeSalon.value = data.element.prestigeSalon ? data.element.prestigeSalon : ''
        vm.formUpdate.fields.prestigeSalonValue.value = data.element.prestigeRappel1 ? data.element.prestigeRappel1 : 0
        vm.formUpdate.fields.prestigeRappel1.value = data.element.prestigeRappel1 ? data.element.prestigeRappel1 : 0
        vm.formUpdate.fields.prestigeRappel2.value = data.element.prestigeRappel2 ? data.element.prestigeRappel2 : 0
        vm.formUpdate.fields.prestigeSection1.value = data.element.prestigeSection1 ? data.element.prestigeSection1 : 0
        vm.formUpdate.fields.prestigeSection2.value = data.element.prestigeSection2 ? data.element.prestigeSection2 : 0
        vm.formUpdate.fields.prestigePotential.value = data.element.prestigePotential ? data.element.prestigePotential : 0
        vm.formUpdate.fields.prestigeEducation.value = data.element.prestigeEducation ? data.element.prestigeEducation : 0
        vm.formUpdate.fields.prestigeRappelFrequency.value = data.element.prestigeRappelFrequency ? data.element.prestigeRappelFrequency : ''
        vm.formUpdate.fields.prestigeDiscount1.value = data.element.prestigeDiscount1 ? data.element.prestigeDiscount1 : 0
        vm.formUpdate.fields.prestigeDiscount2.value = data.element.prestigeDiscount2 ? data.element.prestigeDiscount2 : 0
        vm.formUpdate.fields.prestigeVariableDiscount1.value = data.element.prestigeVariableDiscount1 ? data.element.prestigeVariableDiscount1 : 0
        vm.formUpdate.fields.prestigeVariableDiscount2.value = data.element.prestigeVariableDiscount2 ? data.element.prestigeVariableDiscount2 : 0
        vm.formUpdate.fields.premiumDate.value = data.element.premiumDate ? this.parseDate(data.element.premiumDate.iso) : ''
        vm.formUpdate.fields.premiumPotential.value = data.element.premiumPotential ? data.element.premiumPotential : 0
        vm.formUpdate.fields.premiumRappelFrequency.value = data.element.premiumRappelFrequency ? data.element.premiumRappelFrequency : ''
        vm.formUpdate.fields.prorated.value = proratedFakeValue
        vm.formUpdate.fields.proratedMonth.value = data.element.proratedMonth ? data.element.proratedMonth : ''
        vm.formUpdate.fields.manualDate.value = data.element.manualDate ? this.parseDate(data.element.manualDate.iso) : ''
        vm.formUpdate.fields.observations.value = data.element.observations ? data.element.observations : ''
        vm.formUpdate.fields.conditions.value.mailConditions = !!data.element.mailConditions
        vm.formUpdate.fields.conditions.value.imageConditions = !!data.element.imageConditions

        if (data.element.pdf) {
          vm.formUpdate.fields.pdf.fileReady = true
          vm.formUpdate.fields.pdf.value.data = data.element.pdf
          vm.formUpdate.fields.pdf.value.format = 'pdf'
          vm.formUpdate.fields.pdf.value.size = 0
        }

        vm.displayUpdateContract = true
      } else if (data.action == 'archive') {
        vm.archiveContract(data.element)
      }
    },
    searchClients (data) {
      let vm = this

      vm.getSearchClients = true

      let dataToSend = '?clientCode=' + data

      api
        .clients
        .getClients(dataToSend)
        .then((response) => {
          vm.getSearchClients = false

          if (response.status != 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let clients = response.data.clients

          clients = _.map(clients, (client) => {
            return {
              fakeValue: client.legalName + ' (' + client.clientCode + ')',
              value: client
            }
          })

          vm.formCreate.fields.client.options = clients
          vm.formUpdate.fields.client.options = clients
        })
    },
    clientSelected (data) {
      let vm = this

      vm.formCreate.fields.client.value = data.id
      vm.formUpdate.fields.client.value = data.id

      if (data.associatedAccounts.length == 0) {
        return
      }

      let value = {}
      let options = {}

      _.map(data.associatedAccounts, (associatedAccount) => {
        value[associatedAccount.clientCode] = true

        options[associatedAccount.clientCode] = {
          name: associatedAccount.legalName + ' (' + associatedAccount.clientCode + ')',
          cif: associatedAccount.cif,
          legalName: associatedAccount.legalName,
          email: associatedAccount.email,
          employeesQuantity: associatedAccount.employeesQuantity,
          disabled: true
        }
      })

      vm.formCreate.fields.associateAccounts.value = value
      vm.formCreate.fields.associateAccounts.options = options
      vm.formCreate.fields.associateAccounts.display = true
      vm.formUpdate.fields.associateAccounts.value = value
      vm.formUpdate.fields.associateAccounts.options = options
      vm.formUpdate.fields.associateAccounts.display = true
    },
    exportContracts () {
      let vm = this

      if (vm.exportContractsActive) {
        let message = {
          message: [vm.$t('private.history.contracts.please_wait')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      let contractHistory

      if (vm.selectYears.value) {
        contractHistory = vm.contractHistoryOptions.find(element => {
          return element._id === vm.selectYears.value
        })
      } else {
        contractHistory = vm.contractHistoryOptions[0]
      }

      if (!contractHistory) return false

      vm.exportContractsActive = true

      let dataToSend = {
        className: contractHistory.classNameContract,
        timeZone: moment.tz.guess()
      }

      api
        .contractsHistory
        .exportContracts(dataToSend)
        .then((response) => {
          vm.exportContractsActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let file = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          // let fileURL = URL.createObjectURL(file)

          FileSaver.saveAs(file, 'historico_contrato.xlsx')

          vm.getContracts()
        })
    },
    getDelegations () {
      let vm = this

      vm.getDelegationsActive = true

      let dataToSend = '/?descending=createdAt'

      api
        .delegations
        .getDelegations(dataToSend)
        .then((response) => {
          vm.getDelegationsActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let delegations = response.data.delegations

          delegations = _.map(delegations, (delegation) => {
            return {
              fakeValue: delegation.name,
              value: delegation.id
            }
          })

          vm.filters.delegation.options = delegations
        })
    },
    parseDate (date) {
      let _date = _.has(date, 'iso') ? date.iso : date

      return moment(_date).format('DD-MM-YYYY')
    },
    resetDataMigrateContractsWindow () {
      let vm = this

      vm.migrateContractsWindow.contractsToCreated = []
      vm.migrateContractsWindow.contractsWithErrors = []
      vm.migrateContractsWindow.fields.csv.value = {}
      vm.migrateContractsWindow.fields.csv.fileReady = false
    },
    migrateContractsSubmit () {
      let vm = this

      let dataToSend = {
        separator: vm.migrateContractsWindow.fields.separator.value,
        csv: vm.migrateContractsWindow.fields.csv.value.data
      }

      vm.migrateContractsWindow.migrateCSVFileActive = true

      api
        .contracts
        .migrateCSVFile(dataToSend)
        .then((response) => {
          vm.migrateContractsWindow.migrateCSVFileActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          if (!response.data.success) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          vm.migrateContractsWindow.contractsToCreated = response.data.contractsToCreated
          vm.migrateContractsWindow.contractsWithErrors = response.data.contractsWithErrors

          console.log(vm.migrateContractsWindow.contractsToCreated)
        })
    },
    exportZipPDFs () {
      let vm = this

      if (vm.exportZipPDFsWindow.downloadZipPDFsActive) {
        let message = {
          message: [vm.$t('private.history.contracts.please_wait')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      let month = vm.exportZipPDFsWindow.fields.month.value
      let year = vm.exportZipPDFsWindow.fields.year.value

      if (!moment().isAfter(year + '-' + month + '-' + moment(year + '-' + month).endOf('month').format('DD'), 'year') || !moment().isAfter(year + '-' + month + '-' + moment(year + '-' + month).endOf('month').format('DD'), 'month')) {
        let message = {
          message: [vm.$t('errors.custom.008')],
          type: 'error'
        }

        vm.$root.$emit('showMessage', message)

        return
      }

      let since = year + '-' + month + '-01'
      let until = year + '-' + month + '-' + moment(year + '-' + month).endOf('month').format('DD')

      vm.exportZipPDFsWindow.downloadZipPDFsActive = true

      let dataToSend = {
        since,
        until
      }

      api
        .contracts
        .exportZipPDFs(dataToSend)
        .then((response) => {
          vm.exportZipPDFsWindow.downloadZipPDFsActive = false

          if (response.status !== 200) {
            let message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            }

            vm.$root.$emit('showMessage', message)

            return
          }

          let file = new Blob([response.data], {type: 'octet/stream'})
          // let fileURL = URL.createObjectURL(file)

          FileSaver.saveAs(file, 'pdfs_' + since + '_' + until + '.zip')

          vm.exportZipPDFsWindow.display = false
        })
    }
  },
  components: {
    MenuMoreOptions,
    TextField,
    TextareaField,
    SelectField,
    SearchField,
    CheckboxField,
    FileField,
    DateField,
    SortField
  },
  created () {
    let vm = this

    vm.getDelegations()

    vm.optionsGetContractsHistory()

    for (let i = 2016; i <= moment().year(); i++) {
      vm.createHistoryWindow.fields.year.options.push({
        fakeValue: i,
        value: i
      })
    }

    vm.sessionUser = JSON.parse(localStorage.getItem('sessionUser'))
  }
}



// WEBPACK FOOTER //
// ./src/components/private/history/contracts/script.js